import { createSelector } from 'reselect'
import { listFeatureStateSelector } from './listFeatureStateSelector'

export const totalSelector = createSelector(
  listFeatureStateSelector,
  state => state.total
)
